import cx from "classnames";
import ExpandableFeedItem from "modules/Core/components/Feed/ExpandableFeedItem";
import Container from "modules/Core/sub-modules/ui-kit/components/Container";
import Text from "modules/Core/sub-modules/ui-kit/components/Text";
import Title from "modules/Core/sub-modules/ui-kit/components/Title";
import Stamps from "modules/Core/sub-modules/ui-kit/components/Stamps";
import { STAMPS } from "modules/Core/consts";
import styles from "./styles.module.scss";

export const ActivityTitle = ({ title, stamps, appendage }) => (
    <Container className={styles.titleContainer} flex spaceBetween alignCenter maxWidth>
        <Title className={styles.title} Element="h4">{title}</Title>
        <Container flex alignCenter>
            {appendage}
            <Stamps stamps={[
                stamps?.[STAMPS.COMMENCED] && { stamp: "Commenced", timestamp: stamps?.[STAMPS.COMMENCED] },
                stamps?.[STAMPS.COMPLETED] && { stamp: "Completed", timestamp: stamps?.[STAMPS.COMPLETED] },
            ]} />
        </Container>
    </Container>
)

const ActivityCard = ({
    title,
    text,
    stamps,
    options,
    children,
    headerAppendage,
    className,
}) => (
    <ExpandableFeedItem
        className={cx(
            styles.container,
            className,
            {
                [styles.commenced]: Boolean(stamps?.[STAMPS.COMMENCED]),
                [styles.completed]: Boolean(stamps?.[STAMPS.COMPLETED])
            }
        )}
        headerProps={{ children: null }}
        label={<ActivityTitle title={title} stamps={stamps} appendage={headerAppendage} />}
        size={"xlg"}
    >
        {options && (
            <Container flex flexEnd>
                {options}
            </Container>
        )}
        {text && (
            <Container className={styles.textContainer}>
                <Text p1>
                    {text}
                </Text>
            </Container>
        )}
        {children}
        <Container flex flexEnd mt1 bt1grey>
            <Container flex flexEnd mt1 fullWidth>
                <Stamps stamps={[
                    stamps?.[STAMPS.COMMENCED] && { stamp: "Commenced", timestamp: stamps?.[STAMPS.COMMENCED] },
                    stamps?.[STAMPS.COMPLETED] && { stamp: "Completed", timestamp: stamps?.[STAMPS.COMPLETED] }
                ]} />
            </Container>
        </Container>
    </ExpandableFeedItem>
)

export default ActivityCard;
